<template>
  <div  ref="upload"  >
    <div v-if="limit === 1 && list === 'false'">
      <div class="box" v-if="imageUrl" >
        <img :src="imageUrl" class="avatar" :style="avatarStyle">
        <div class="box-content" slot="tip" v-if="editMode">
          <ul class="icon">
             <li :title="$lang('添加')" ref="plusUploaderBtn" @click="showUploadDlg">
              <a href="#" ><i class="el-icon-plus"></i></a>
             </li >
            <li :title="$lang('下载')" @click="downloadAttachment(fileList[0])"><a href="#" style="background:#67C23A"><i class="el-icon-download"></i></a></li>
            <li :title="$lang('删除')" v-if="recordIsCanEdit(fileList[0])" @click="beforeRemove(fileList[0])">
              <a href="#" style="background:#E6A23C"><i class="el-icon-close"></i></a>
            </li >
          </ul>
        </div>
      </div>
      <el-button size="small" :type="type" :plain="plain" ref="uploaderBtn" @click="showUploadDlg" v-else-if="editMode">
        <i v-if="!!icon" :class="icon" :style='{margin:label?undefined:"0",padding:label?undefined:"0"}'></i>{{label}}
      </el-button>
    </div>
    <div v-else>
      <el-button v-if="editMode" size="small" :type="type" :plain="plain" ref="uploaderBtn" @click="showUploadDlg">
        <i v-if="!!icon" :class="icon" :style='{margin:label?undefined:"0",padding:label?undefined:"0"}'></i>{{label}}
      </el-button>
      <el-progress v-if="editMode && flag== true" :percentage="uploadPercent" style="margin-top:5px;" format="format"></el-progress>
      <div>
        <ul class="el-upload-list el-upload-list--text" >
          <li v-for="item in fileList" class="el-upload-list__item is-success uploadList" style="position:relative">
            <a   class="el-upload-list__item-name" :name="item.id" @click="downloadAttachment(item)"><i class="el-icon-document" ></i>{{item.name}}
            </a>
            <!--<i class="el-icon-download ele-icon download" @click="downloadAttachment(item)" style="float: right; margin-top: -21px;margin-right: 40px;color:red;"></i>-->
            <label class="el-upload-list__item-status-label"><i class="el-icon-upload-success el-icon-circle-check ele-icon"></i></label>
            <i v-if="editMode && recordIsCanEdit(item)" class="el-icon-close ele-icon"  @click="beforeRemove(item)"></i>
            <div v-show="item.imageUrl" style="margin-bottom:5px">
              <img :src="item.imageUrl" class="avatar" :style="avatarStyle">
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

</template>
<script>
  import token from "@/common/utils/token";
  export default
  {

    name:'form-attachment-list-min',
    data() {
      let me=this;
      let config=this.$options.config;
      let editMode=!config.getCurrentObject().isTextMode();
      let businessId=config.getData().businessId;
      let batchId=config.getFormObject().batchId||"";
      let $dd=config.getConfig() || {};
      if(!$dd.buttonIcon && !$dd.buttonLabel) $dd.buttonLabel=$lang("选择文件");
      if($dd.buttonLabel) $dd.buttonLabel = $lang($dd.buttonLabel);
      return {
        uploader:null,
        editMode:editMode,
        label:$dd.buttonLabel || "",
        icon:$dd.buttonIcon || "",
        type:$dd.colorCls ||"primary",
        plain:!!$dd.plain,
        config: config,
        fileList: [],
        accept: '',
        maxSize: 10,
        limit: 1,
        list: '',
        imageUrl: '',
        showUploadDialog:'',
        defaultParams:{
          formId:'',
          businessId:'',
          type:'',
          tempBusinessId:'',
          fullPath:"y",
          batchId:batchId
        },
        headers: {},
        flag:false,
        avatarStyle:{
          width:'150px',
          height:'150px'
        },
        action: this.mwUrl('/api/business/uploadAttachment'),
        uploadPercent:0
      }
    },

    created() {

    },
    mounted() {
      let me=this;
      this.defaultParams.formId = this.$options.params.formId;
      this.defaultParams.businessId = this.$options.params.businessId;
      this.defaultParams.tempBusinessId =this.$options.params.tempBusinessId ;
      this.defaultParams.checkAttchSize=true;
      this.defaultParams.fullAuthType = this.$options.params.fullAuthType||"";
      let config = this.$options.config.getConfig();
      this.$options.config.getCurrentObject().$obj =  this;
      this.defaultParams.type = config.fileType || 'JOA_FJ';
      this.maxSize = config.fileSize || 10;
      this.list = config.list || 'true';
      if(config.limit && config.limit === 'true'){
        this.limit = null;
      }
      else{
        this.limit = 1;
      }
      this.showUploadDialog=config.showUploadDialog==='1'
      this.refresh(function(){
        if(config.fileExtension){
            me.accept = config.fileExtension;
            me.$nextTick(function() {
                me.initPupload();
            })
        }else{
            me.accept = PF._sysConfig && PF._sysConfig.uploadAttachFormat || "";
            me.maxSize = config.fileSize || (PF._sysConfig && PF._sysConfig.uploadAttachMaxSize) || 10;
            me.initPupload();
        }
          if(me.list === 'false'){
            if(config.pwidth){
              me.avatarStyle.width = config.pwidth+'px';
            }else{
              me.avatarStyle.width = '150px';
            }
            if(config.pheight){
              me.avatarStyle.height = config.pheight+'px';
            }
            else{
              me.avatarStyle.height = '150px';
            }
          }
      });
    },
    methods: {
      recordIsCanEdit:function(row){
        if(window.PF&&PF.action&&PF.action.formAttachmentIsCanEdit){
          return PF.action.formAttachmentIsCanEdit(this.config,[row]);
        }else{
          return true;//默认显示
        }
      },
      initPupload(){
        let me=this;
        let buttonId;
        if(!me.editMode || me.showUploadDialog) return;
        if(me.limit === 1 && me.list === 'false' && me.imageUrl && me.editMode){
            buttonId= me.mwRef('plusUploaderBtn');
        }else{
            let uploadRef=me.mwRef('uploaderBtn');
            if(uploadRef)
            buttonId= uploadRef.$el;
        }
        if(!buttonId)return; //没有上传按钮了不需要初始化上传控件。初始化会报错。
        PF.requireJs(["/assets/js/Plupload/js/plupload.full.min.js"],function(){
          var cfg={
            runtimes : 'gears,html5,flash,silverlight,browserplus,html4',
            browse_button : buttonId, //选择文件按钮ID
            max_file_size : me.maxSize+'mb',  //文件上传最大值
            unique_names : true,  // 上传的文件名是否唯一,只有在未进行分块上传时文件名唯一才有效
            url :me.action ,//提交到后台的url地址
            multi_selection: me.limit==null?true:false, //能否多选
            flash_swf_url : '/assets/js/Plupload/js/Moxie.swf',//plupload.flash.swf文件所在路径
            silverlight_xap_url : '/assets/js/Plupload/js/Moxie.xap'//silverlight所在路径
          }
          if(me.accept){
            cfg.filters={mime_types:[
                {title : $lang("自定义文件"), extensions : me.accept}
              ] }
          }
          var uploader = new plupload.Uploader(cfg);
          me.uploader=uploader;
          if(me.$options.config && me.$options.config.getFormObject
            && me.$options.config.getFormObject() && me.$options.config.getFormObject().$newForm){
              me.$options.config.getFormObject().$newForm.uploaderPage = me;
          }
          uploader.bind('FilesAdded', function (up, files) {
            if(me.limit==1 && me.fileList[0]){
              uploader.setOption("url",me.mwUrl('/api/business/updateAttachment'));
              me.defaultParams.uploadType="update";
              me.defaultParams.attachId=me.fileList[0].id;
            }
            var formObj = me.$options.config.getFormObject();
            if(formObj && formObj.$newForm){
              formObj.$newForm.fireEvent("FilesAdded",up, files,me.config);
            }
            //处理新建保存后上传附件更新businessId
            me.defaultParams.businessId=me.$options.config.getFormObject().businessId || "";
            if (me.defaultParams.businessId) {
              me.defaultParams.tempBusinessId="";
            }
            if(me.$options.config.getFormObject().extParams)
              me.defaultParams.fullAuthType=me.$options.config.getFormObject().extParams.fullAuthType||"";
            uploader.setOption("multipart_params",me.defaultParams);
            uploader.start();
          });
          uploader.bind('UploadProgress',function(up, file) {
            me.flag = true;
            me.uploadPercent=file.percent.toFixed(0);
          });
          uploader.bind('UploadComplete',function(up, files) {
            var formObj = me.$options.config.getFormObject();
            if(formObj && formObj.$newForm){
              formObj.$newForm.fireEvent("beforeUploadComplete",up, files,me.config);
            }
            me.handleSuccess(up,files);
            if(formObj && formObj.$newForm ){
              formObj.$newForm.fireEvent("afterUploadComplete",up, files,me.config);
            }
          });
          uploader.bind('FileUploaded', function(up, file, obj) {
            let r;

            try {
              r=JSON.parse(obj.response || "{}");
            } catch(err) {
            }
            if(r.success){
              if(r.result && r.result.msg){
                PF.alert(r.result.msg)
              }
            }else{
              PF.alert(r.errMsg || "上传出错");
            }
          });
          uploader.bind('Error', function(up, err) {
            var response=(err&&err.response)?JSON.parse(err.response):"";
            if(response && response.result){
              me.$message.warning(response.result.msg);
            }else {
              if (err.message.indexOf("File size error") != -1)
                me.$message.error($lang('上传附件大小不能超过') + me.maxSize + 'MB!');
              else if (err.message.indexOf("File extension error") != -1)
                me.$message.error($lang("只能上传文件类型:") + " " + me.accept);
              else
                me.$message.warning(err.code + ":" + err.message + (err.file ? ", File: " + err.file.name : ""));
            }
            up.refresh();
          });
          uploader.init();
        });
      },
      showUploadDlg() {
        let me=this;
        if(!me.editMode || !me.showUploadDialog) return;
        let type=me.defaultParams.type;
        let batchId=me.defaultParams.batchId;
        let params = {type:type,businessId:me.$options.params.businessId,tempBusinessId:me.$options.params.tempBusinessId,formId:me.$options.params.formId,batchId:batchId,editable:me.editMode}
        if(me.accept){
          params.accept = me.accept;
        }
        let formObj = me.$options.config.getFormObject();
        if(formObj && formObj.$newForm){
          formObj.$newForm.fireEvent("beforeShowUpload",params,me);
        }
        PF.show('attachment',params,()=>{
          me.refresh();
        });

      },
      handleSuccess(up, files) {
        let me=this;
        me.flag = false;
        me.uploadPercent = 0;
        me.refresh(function(){
          me.$nextTick(function() {
            me.uploadDestroy();
            me.initPupload();
          })
        });

      },
      beforeRemove(file) {
        let me=this;
        me.$confirm($lang('确定移除')+file.name+$lang('文件')+'?', $lang('提示'), {
          confirmButtonText: $lang('确定'),
          cancelButtonText: $lang('取消'),
          type: 'warning'
        }).then(() => {
          let params = Object.assign({attachIds:[file.id]},me.defaultParams);
          me.mwApi.business.deleteAttachment(params).then(res =>{
            if(res.success){
              me.$message({
                type: 'success',
                message: $lang('删除成功!')
              });
              me.refresh(function(){
                me.$nextTick(function() {
                  me.uploadDestroy();
                  me.initPupload();
                })
              });
            }
          })
        })
      },
      refresh(callback){
        var me = this;
        //重新获取businessId,可能起草的时候保存了。
        this.defaultParams.businessId=this.$options.config.getFormObject().businessId;
        if (this.defaultParams.businessId) {
          this.defaultParams.tempBusinessId="";
        }
        this.mwApi.business.listAttachment(this.defaultParams).then(res =>{
          if(res.success){
            this.fileList = res.result || [];
            var formObj = me.$options.config.getFormObject();
            formObj.$newForm.fireEvent("attachmentload",this.fileList,me.config);
            let config = this.$options.config.getConfig();
            let formId = this.$options.params.formId;
            let businessId = this.$options.params.businessId;
            let tempBusinessId =this.$options.params.tempBusinessId;
            if(config.list){
              if(config.list === 'true'){

              }else{
                if(this.fileList.length != 0){
                  if(config.limit === 'false'){
                    let id = this.fileList[0].id;
                    let string = 'id='+id+'&businessId='+businessId+'&formId='+formId+'&tempBusinessId='+tempBusinessId+'&_t='+Math.random();
                    this.imageUrl =  this.mwUrl("/api/business/downloadAttachment?")+string;
                  }
                  else{
                    this.fileList.forEach( f =>{
                      let string = 'id='+f.id+'&businessId='+businessId+'&formId='+formId+'&tempBusinessId='+tempBusinessId+'&_t='+Math.random();
                      f.imageUrl =  this.mwUrl("/api/business/downloadAttachment?")+string;
                    })
                  }
                }else{
                  this.imageUrl = '';
                }
              }
            }
          }
          if(callback) callback();
        });
      },
      handleAvatarSuccess(res, file) {
        if(this.fileList.length > 0){
          let ids =  [];
          this.fileList.forEach( f =>{
            ids.push(f.id)
          });
          let params = Object.assign({attachIds:ids},this.defaultParams);
          this.mwApi.business.deleteAttachment(params).then(res =>{
            if(res.success){
              this.refresh()
            }
          });
        }else{
          this.refresh()
        }

      },
      downloadAttachment(data){
         var me=this;
         let params={}
         params.id=data.id;
         params.businessId=this.$options.params.businessId;
         params.formId=this.$options.params.formId;
         params.tempBusinessId=this.$options.params.tempBusinessId;
         params.editMode=me.editMode;
         if(window.PF&&PF.action&&PF.action["attachment_preview"]){
            let formObj=me.$options.config.getFormObject?me.$options.config.getFormObject():{};
             PF.action["attachment_preview"](params,formObj,me);
             return;
          }
         me.mwApi.business.downloadAttachment(params);
      },
      isCloseAttachDownload(){
        let formObj = this.$options.config.getFormObject();
        let closeAttachDownload = false;
        if(formObj  && formObj.type=="module_flow"){
          let sysConfig = formObj.$store.getters.sysConfig;
          if(sysConfig && sysConfig.closeAttachDownload){
            if(!(!_.isEmpty(formObj.activity) && (formObj.activity.downloadAttach == undefined || formObj.activity.downloadAttach==1))){
              closeAttachDownload = true;
            }
          }
        }
        return closeAttachDownload;
      },
      onChange(name, val, d){
        //表单设计时候改变配置内容传的值
        let me=this;

        switch (name) {
          case 'buttonLabel':
            me.label=val;
            break;
          case 'buttonIcon':
            me.icon=val;
            break;
          case 'colorCls':
            me.type=val;
            break;
          case 'plain':
            me.plain=val;
            break;
          default:
        }
      },
      uploadDestroy(){
        if(this.uploader && this.uploader.destroy)
          this.uploader.destroy();
      },
      format(percentage) {
        return parseInt(percentage) === 100 ? '满' : `${percentage}%`;
      },
    }

  }
</script>

<style scoped>
  .el-upload-list__item-name {
    color: #606266;
    display: block;
    margin-right: 40px;
    overflow: hidden;
    padding-left: 10px;
    text-overflow: ellipsis;
    -webkit-transition: color .3s;
    transition: color .3s;
    white-space: nowrap;
  }
  .avatar {
    display:inline-block;
  }

  .uploadList:hover .download{
    display: block
  }

  .ele-icon{
    font-size:16px;
  }

  .box{
    text-align: center;
    overflow: hidden;
    position: relative;
  }
  .box:before{
    content: "";
    width: 0;
    height: 100%;
    background: #000;
    padding: 14px 18px;
    position: absolute;
    top: 0;
    left: 50%;
    opacity: 0;
    transition: all 500ms cubic-bezier(0.47, 0, 0.745, 0.715) 0s;
  }
  .box:hover:before{
    width: 100%;
    left: 0;
    opacity: 0.5;
  }

  .box .box-content{
    width: 100%;
    padding: 14px 18px;
    color: #fff;
    position: absolute;
    top: 30%;
    left: 0;
  }

  .box .icon{
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .box .icon li{
    display: inline-block;
  }
  .box .icon li a{
    display: block;
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 50%;
    background: #f74e55;
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.5s ease 0s;
  }
  .box:hover .icon li a{
    opacity: 1;
    transform: translateY(0px);
    transition-delay: 0.5s;
  }
  .box:hover .icon li:last-child a{
    transition-delay: 0.8s;
  }
  .download{
    display: none;
  }
  .download:hover{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/extend/form/src/components/attachment-list-min.vue